module.exports = __webpack_public_path__ + "src/images/flag-en.png?2878f64a0217a154e531853f6a822c65";


//////////////////
// WEBPACK FOOTER
// ./src/images/flag-en.png
// module id = 898
// module chunks = 0